import React, { useEffect, useMemo, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { fetchRealTimeUsersData } from '../../api/user';
import { useSelector } from 'react-redux';

const RealTimeUsers = ({titletext}) => {
  const [data, setData] = useState([]);
  const [onlineUsersCount, setOnlineUsersCount] = useState(0);
  // const { filter } = useSelector((state) => state);
      const filter = useSelector((state) => state.filter);
      const filterWithoutUTM = useMemo(() => {
        const { utm_options, ...rest } = filter;
        return rest;
      }, [JSON.stringify(filter)]);

  const fetchData = async () => {
    try {
      await fetchRealTimeUsersData(filter, setOnlineUsersCount, setData);
    } catch (error) {
      console.error('Error while loading real-time data', error);
    }
  };

useEffect(() => {
  // Run immediately once
  fetchData();
  // Set up 30s interval
  const intervalId = setInterval(() => {
    fetchData();
  }, 30000); // 30 seconds
  // Cleanup on unmount or when filter changes
  return () => clearInterval(intervalId);
}, [JSON.stringify(filterWithoutUTM)]);

  const todayDate = new Date();
  const today = todayDate.getTime() - todayDate.getTimezoneOffset() * 60 * 1000;

  const options = {
    chart: {
      backgroundColor: '#fff', // Background color for the entire chart
    },
    title: {
      text: titletext,
      align: 'left', // Align the title to the left
      verticalAlign: 'top', // Align the title to the top
      x: 0, // Set x to 0 for exact positioning from the left
      y: 10, // Adjust the vertical position of the title
      style: {
        fontSize: '16px', // Font size for the title
        fontWeight: 'bold', // Font weight for the title
        color: '#000', // Color of the title
      },
    },
    subtitle: {
      text: onlineUsersCount, // The text for the subtitle
      align: 'left', // Align the subtitle to the left
      verticalAlign: 'top', // Align the subtitle to the top
      x: 0, // Set x to 0 to keep it aligned with the title
      y: 40, // Adjust the vertical position of the subtitle (below the title)
      style: {
        fontSize: '24px', // Font size for the subtitle
        fontWeight: 'bold', // Font weight (e.g., normal, bold)
        color: '#000', // Font color
        textAlign: 'left', // Text align left (for additional precision)
        textTransform: 'uppercase', // Optional: Make the text uppercase
      },
    },
    credits: {
      enabled: false, // Hide Highcharts credits (watermark)
    },
    xAxis: {
      type: 'datetime',
      plotLines: [
        {
          color: '#008E40',
          width: 2,
          value: today,
          zIndex: 2,
          dashStyle: 'Dash',
          label: {
            text: 'Current time',
            rotation: 0,
            y: 20,
            style: {
              color: '#333333',
            },
          },
        },
      ],
      opposite: true, // Moves the x-axis and labels to the top
      labels: {
        align: 'center', // Align the labels to the center
        y: -10, // Move the labels slightly above the axis line
      },
      lineWidth: 0, // Hide the x-axis line by setting the line width to 0
    },
    yAxis: {
      title: {
        text: '',
      },
      labels: {
        enabled: false, // Hide the y-axis labels
      },
      gridLineWidth: 0, // Optional: Remove grid lines
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      valueSuffix: 'User',
    },
    plotOptions: {
      series: {
        marker: {
          radius: 5, // Marker size
          fillColor: '#ffffff', // Marker fill color
          lineWidth: 2, // Marker border width
          lineColor: '#008E40', // Marker border color
        },
        lineWidth: 4,
        shadow: true, // Shadow effect for the line
      },
    },
    series: [
      {
        type: 'area', // Set the series type to 'area' to fill below the line
        name: 'Online users',
        data: data,
        zoneAxis: 'x',
        color: {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, '#008E40'], // Color at the top of the area (gradient start)
            [1, '#008E40'], // Color at the bottom of the area (gradient end)
          ],
        },
        fillColor: {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 }, // Direction of the gradient
          stops: [
            [0, 'rgba(0, 142, 64, 0.7)'], // Gradient start color (top)
            [1, 'rgba(217, 217, 217, 0)'], // Gradient end color (bottom)
          ],
        },
        zones: [
          {
            value: today,
          },
          {
            dashStyle: 'Dot',
          },
        ],
      },
    ],
    plotBackgroundColor: '#e1f7ff',
    plotBorderWidth: 0,
    plotBorderColor: '#4840d6', // Border color around the plot area
  };

  return (
    <div className="p-20 border rounded-4">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default RealTimeUsers;
